import Index from './views/Index'

export default [{
  path: '/network/:code/reports',
  name: 'network.reports',
  component: Index
}]
